import * as Action from '../actions';
const initialState = {
  errorMsg: null,
  type: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Action.CREATE_ERROR:
      return {
        errorMsg: action.payload.msg,
        type: action.payload.type,
      };
    case Action.HIDE_ERROR:
      return {
        errorMsg: null,
        type: null,
      };
    default:
      return state;
  }
};
export default reducer;
